import { render, staticRenderFns } from "./UnverifiedTickets.vue?vue&type=template&id=d896def6&"
import script from "./UnverifiedTickets.vue?vue&type=script&lang=js&"
export * from "./UnverifiedTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports